const MERCHANT_PAY_MARKER = '/pay/payAdd?key='
const INVALID_SCAN_RESULT = Object.freeze({ type: 'invalid' })

const parseScanPayContent = (decodedText = '') => {
    if (typeof decodedText !== 'string') {
        return INVALID_SCAN_RESULT
    }

    const markerIndex = decodedText.indexOf(MERCHANT_PAY_MARKER)

    if (markerIndex !== -1) {
        const keyStart = markerIndex + MERCHANT_PAY_MARKER.length
        const encodedKey = decodedText.slice(keyStart).split(/[&#]/)[0]

        try {
            const key = decodeURIComponent(encodedKey.replace(/\+/g, ' '))

            if (!key.trim()) {
                return INVALID_SCAN_RESULT
            }

            return { type: 'merchant', key }
        } catch (error) {
            return INVALID_SCAN_RESULT
        }
    }

    if (decodedText.includes('order')) {
        return { type: 'legacy' }
    }

    return INVALID_SCAN_RESULT
}

const normalizeMerchantPayAmount = (value = '') => {
    const amount = String(value == null ? '' : value).trim()

    if (!/^\d+(?:\.\d{1,2})?$/.test(amount)) {
        return ''
    }

    const [integerPart, decimalPart = ''] = amount.split('.')

    if (!/[1-9]/.test(`${integerPart}${decimalPart}`)) {
        return ''
    }

    const normalizedInteger = integerPart.replace(/^0+(?=\d)/, '')

    return `${normalizedInteger}.${decimalPart.padEnd(2, '0')}`
}

const getDefaultCrypto = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.crypto || null
}

const createRequestNo = (
    cryptoObject = getDefaultCrypto(),
    now = Date.now,
    random = Math.random
) => {
    if (cryptoObject && typeof cryptoObject.getRandomValues === 'function') {
        const bytes = new Uint8Array(16)
        cryptoObject.getRandomValues(bytes)

        return Array.from(bytes)
            .map(byte => byte.toString(16).padStart(2, '0'))
            .join('')
    }

    let requestNo = Math.max(0, Number(now()) || 0).toString(16)

    while (requestNo.length < 32) {
        const randomBlock = Math.floor((Number(random()) || 0) * 0x100000000)
        requestNo += randomBlock.toString(16).padStart(8, '0').slice(-8)
    }

    return requestNo.slice(0, 32)
}

module.exports = {
    createRequestNo,
    normalizeMerchantPayAmount,
    parseScanPayContent
}
